import request from '@host-panel/request';

type RequestPayload = {
  roles: string[];
  userId: string;
};

export function unassignRole({ userId, roles }: RequestPayload): Promise<{}> {
  return request(`/host-panel/team/roles`, {
    method: 'DELETE',
    data: {
      roles,
      member_id: userId
    }
  });
}
